<template>
    <div>
        <layout>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <ChildDeviceItem v-for="item in childDeviceList" :key="item.id" :childDevice="item" @onUpdate="onUpdate" @onRefresh="onRefresh"/>
                </List>
            </PullRefresh>
        </layout>
        <Icon v-if="subDeviceAddWay=='App'" name="plus" size="35px" color="#fff" @click="$router.push('/device/install/child/'+deviceId)"
              class="float-btn-add"/>
        <Popup :show="popupPanel" type="Popup" @panel="switchPanel"
                           :key="selected.id" :item="selected" @onRefresh="onRefresh"/>
    </div>
</template>

<script>
    import {Button, Field, Icon, List, PullRefresh} from "vant"
    import ChildDeviceItem from "../components/ChildDeviceItem";
    import Popup from "../components/Popup"

    export default {
        components: {
            ChildDeviceItem,Popup,
            List, Field, Button, Icon, PullRefresh
        },
        props: {},
        data() {
            return {
                deviceId: this.$route.params.id,
                isReFresh: false,
                finished: false,
                loading: false,
                productPanel: false,
                childDeviceList: [],
                subDeviceAddWay:"",
                selected:{},
                popupPanel:false
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            switchPanel(type) {
                switch (type) {
                    case "Popup":
                        this.popupPanel = false;
                        break;
                    default:
                        break;
                }
            },
            onUpdate(selected){
                this.selected=selected
                this.popupPanel=true
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.device.get({id: this.deviceId})
                    .then(res => {
                        if (res) {
                            this.subDeviceAddWay=res.subDeviceAddWay
                            this.childDeviceList.push(...res.subDeviceList);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            this.finished = true;
                        }
                    })
            },
            onRefresh() {
                this.isReFresh = true;
                this.childDeviceList = [],
                    this.onLoad(true);
            },
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .float-btn-add {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 50px;
        right: 20px;
        z-index: 999;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }

    .notice-wrap {
        width: 100%;
        height: 37px;
        box-sizing: border-box;
        border-bottom: 1px solid #f2f2f2;
    }

    .notice-content {
        position: fixed;
        background-color: #fff;
        z-index: 999;
        width: 100%;
    }

    .notice-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }

    .notice-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 15px;
        padding: 3px 0;
    }
</style>
